import { render, staticRenderFns } from "./RemovedProjectsTable.vue?vue&type=template&id=7657fca8&scoped=true&"
import script from "./RemovedProjectsTable.vue?vue&type=script&lang=js&"
export * from "./RemovedProjectsTable.vue?vue&type=script&lang=js&"
import style0 from "./RemovedProjectsTable.vue?vue&type=style&index=0&id=7657fca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7657fca8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VTooltip})
